import { PostRequest } from '@/util/http';

export function APIFetchTrafficPrediction(params: any) {
  return PostRequest('kpi/predictionAndWTE', params);
} // APIFetchTrafficPrediction

export const APIFetchKPIPrediction = (metricKey: string, params: any) => {
  return PostRequest(`kpi/prediction/${metricKey}`, params);
};
